<template>
  <div>
    <div @click="toggle" class="toggle">展开/关闭评论（{{commentListWithSubCommentList.length}}）>></div>
    <div v-if="showComments" class="comments-container">
      <div v-if="commentListWithSubCommentList.length>0">
        <div class="comment-item" v-for="item in commentListWithSubCommentList" :key="item.id+'top'">
          <img @click="goToUserInfo(item.userVo.id)" :src="(item.userVo.avatar==null||item.userVo.avatar=='')?defaultAvatar:item.userVo.avatar" style="display: block;width: 40px;height: 40px;border-radius: 40px;cursor: pointer;"/>
          <div style="display: block;margin-left: 10px;">
            <div style="color: rgb(131, 131, 131);margin-top: 5px;margin-bottom: 5px;">{{item.userVo.userName}}</div>
            <div>
              <div>{{item.content}}</div>
              <div style="color: rgb(131, 131, 131);margin-top: 5px;margin-bottom: 5px;">
                <span>{{item.createTime}}</span>
                <span style="margin-left: 10px;display: inline-block;margin-right: 10px;">
                  <img @click="changeThumbUp(item.id)" :src="item.isThumbUp?redthumbup:thumbup" style="width: 20px;height: 20px;transform: translateY(3px);cursor: pointer;"/>
                  {{item.count}}
                </span>
                <span class="report-comment" @click="changeReplyTo(item.userVo,item.id,null,item.content)">回复</span>
                <span class="report-comment" @click="reportComment(item.id)">举报</span>
                <span v-if="item.userId===($store.getters.token?$store.state.user.user.id:'')">
                  <img @click="delComment(item.id)" :src="commenttrash" style="width: 18px;height: 18px;transform:translateX(15px) translateY(4px);cursor: pointer;"/>
                </span>
              </div>
              <div v-if="item.subCommentList.length>0">
                <div v-for="item2 in item.subCommentList" :key="item2.id+'sub'">
                  <div v-if="item2.aterUserId===item.userId" style="display: flex;">
                   <img @click="goToUserInfo(item2.userVo.id)" :src="(item2.userVo.avatar==null||item2.userVo.avatar=='')?defaultAvatar:item2.userVo.avatar" style="display: block;width: 40px;height: 40px;border-radius: 40px;cursor: pointer;"/>
                   <div style="margin-left: 10px;">
                    <div style="color: rgb(131, 131, 131);margin-top: 5px;margin-bottom: 5px;">{{item2.userVo.userName}}</div>
                    <div>{{item2.content}}</div>
                    <div style="color: rgb(131, 131, 131);margin-top: 5px;margin-bottom: 5px;">
                      <span>{{item2.createTime}}</span>
                      <span style="margin-left: 10px;display: inline-block;margin-right: 10px;">
                        <img  @click="changeThumbUp(item2.id)"  :src="item2.isThumbUp?redthumbup:thumbup" style="width: 20px;height: 20px;transform: translateY(3px);cursor: pointer;"/>
                        {{item2.count}}
                      </span>
                      <span style="margin-left: 10px;cursor: pointer;" @click="changeReplyTo(item2.userVo,item.id,item2.id,item2.content)">回复</span>
                      <span class="report-comment" @click="reportComment(item2.id)">举报</span>
                      <span v-if="item2.userId===($store.getters.token?$store.state.user.user.id:'')">
                        <img @click="delComment(item2.id)" :src="commenttrash" style="width: 18px;height: 18px;transform:translateX(15px) translateY(4px);cursor: pointer;"/>
                      </span>
                    </div>
                   </div>
                  </div>
                  <div v-else  style="display: flex;">
                    <img @click="goToUserInfo(item2.userVo.id)" :src="(item2.userVo.avatar==null||item2.userVo.avatar=='')?defaultAvatar:item2.userVo.avatar" style="display: block;width: 40px;height: 40px;border-radius: 40px;cursor: pointer;"/>
                    <div style="margin-left: 10px;">
                      <div style="color: rgb(131, 131, 131);margin-top: 5px;margin-bottom: 5px;">{{item2.userVo.userName}}</div>
                      <div>
                        回复<span style="color: rgb(131, 131, 131);cursor: pointer;" @click="goToUserInfo(item2.atUserVo.id)">@{{item2.atUserVo.userName}}：</span>
                        <span>{{item2.content}}</span>
                      </div>
                      <div style="color: rgb(131, 131, 131);margin-top: 5px;margin-bottom: 5px;">
                        <span>{{item2.createTime}}</span>
                        <span style="margin-left: 10px;display: inline-block;margin-right: 10px;">
                          <img @click="changeThumbUp(item2.id)"  :src="item2.isThumbUp?redthumbup:thumbup" style="width: 20px;height: 20px;transform: translateY(3px);cursor: pointer;"/>
                          {{item2.count}}
                        </span>
                        <span style="margin-left: 10px;cursor: pointer;" @click="changeReplyTo(item2.userVo,item.id,item2.id,item2.content)">回复</span>
                        <span class="report-comment" @click="reportComment(item2.id)">举报</span>
                        <span v-if="item2.userId===($store.getters.token?$store.state.user.user.id:'')">
                          <img @click="delComment(item2.id)" :src="commenttrash" style="width: 18px;height: 18px;transform:translateX(15px) translateY(4px);cursor: pointer;"/>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div @click="loadMoreComment(item.id,item.pageNo)" v-if="item.hasMore" class="load-more">
                查看更多...
              </div>
            </div>
          </div>
        </div>
        <div @click="loadMoreComment(0,pageNo)" v-if="hasMore" class="load-more" style="margin-left: 70px;">
          查看更多..
        </div>
      </div>
      <div v-else style="margin-left:20px;">暂无评论，快去评论吧</div>
      <div class="comment-text-container">
          <textarea v-model="commentModel" placeholder="请输入评论" ref="commentInput" class="comment-text"></textarea>
          <div class="comment-btn" :style="{color:commentModel.trim()!==''?'white':'#b9b9b9',cursor:commentModel.trim()!==''?'pointer':'not-allowed'}" @click="sendComment">发送</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getComments, changeThumbUp, addComments, delComment } from '@/api/comments'
import { addReportMsg } from '@/api/report'
import defaultAvatar from '@/assets/styles/defaultUser.svg'
import thumbup from '@/assets/styles/thumbup.svg'
import redthumbup from '@/assets/styles/redthumbup.svg'
import commenttrash from '@/assets/styles/commenttrash.svg'
export default {
  name: 'CommentBox',
  props: ['target', 'id'], // 用来接收不同模块传入不同的target值，例如goods模块，就传入goods，它的值会与请求进行拼接，从而向不同的接口发送请求
  data () {
    return {
      commenttrash,
      thumbup,
      redthumbup,
      replyToUser: null, // 用来保存回复对象的
      commentModel: '',
      defaultAvatar,
      commentList: [],
      commentListWithSubCommentList: [],
      commentQuery: {
        pageNo: 1,
        pageSize: 10,
        topId: 0,
        userId: null,
        [this.target + 'Id']: this.id // 这是一个动态的属性值，这要求所有后台评论都按照这个来
      },
      commentDto: {
        topId: 0,
        atId: null,
        atUserId: null,
        goodsId: null,
        content: '',
        originalContent: ''
      },
      hasMore: false, // 这个是用来记录最外层那个是否有更多的标记
      pageNo: 1, // 用来记录最外层的页数的标记
      showComments: false,
      sortedCommentList: [],
      reportedCommentList: new Set([]) // 记录已经举报过的评论的数组，防止重复点击进行举报
    }
  },
  methods: {
    async reportComment (id) {
      if (this.reportedCommentList.has(id)) {
        this.$message({
          message: '该条评论已经举报过了，无需再次举报，请耐心等待审核结果',
          type: 'warning'
        })
        return
      }
      const res = await addReportMsg(id)
      if (res.code === 1) {
        this.reportedCommentList.add(id)
        this.$message({
          message: '举报成功，后台已收到您的举报，稍后会进行审核处理',
          type: 'success'
        })
      }
    },
    async delComment (commentId) {
      const res = await delComment('goods', commentId)
      if (res.code === 1) {
        this.commentListWithSubCommentList = this.commentListWithSubCommentList.filter(item => {
          if (item.id !== commentId) {
            item.subCommentList = item.subCommentList.filter(item2 => {
              return item2.id !== commentId
            })
          }
          return item.id !== commentId
        })
      }
    },
    async loadMoreComment (topId, pageNo) { // 如果topId===0的话，那么就是只加载最顶层的，否则就按照传入的值进行加载
      this.commentQuery.topId = topId
      this.commentQuery.pageNo = pageNo
      const res = await getComments(this.target, this.commentQuery)
      if (res.code === 1) {
        if (topId === 0) { // 最外层的评论的加载更多
          this.hasMore = (res.data.list.length === 10)
          this.pageNo = this.pageNo + 1
          this.commentListWithSubCommentList = this.commentListWithSubCommentList.filter(item => {
            for (let i = 0; i < res.data.list.length; i++) {
              if (res.data.list[i].id === item.id) {
                return false
              }
            }
            return true
          })
          const newCommentListWithSubCommentList = res.data.list.map(item => {
            if (item.topCommentVo !== null) {
              let hasMore = false
              if (Number(item.subCommentCount) > 1) {
                hasMore = true
              }
              return {
                ...item,
                subCommentList: new Array(item.topCommentVo),
                pageNo: 1,
                hasMore
              }
            } else {
              const hasMore = false
              return {
                ...item,
                subCommentList: [],
                pageNo: 1, // 用来记录每条主评论下面的翻页数
                hasMore
              }
            }
          })
          this.commentListWithSubCommentList = this.commentListWithSubCommentList.concat(newCommentListWithSubCommentList)
          return
        }
        // 需要根据返回值结果修改commentListWithSubCommentList中对应的topId值项的subCommentList和pageNo项
        this.commentListWithSubCommentList.forEach(item => {
          if (item.id === topId) {
            // 需求，如果item.subCommentList中有个元素的id和res.data.list中的某个id值一样
            // 则需要将item.subCommentList中或res.data.list中的它去掉，然后再拼接，但是以哪个为准呢？应该以后面的为准，也就是去掉item.subCommentList中它的元素
            item.subCommentList = item.subCommentList.filter(item => {
              for (let i = 0; i < res.data.list.length; i++) {
                if (res.data.list[i].id === item.id) {
                  return false
                }
              }
              return true
            })
            item.subCommentList = item.subCommentList.concat(res.data.list)
            if (res.data.list.length < 10) {
              item.hasMore = false
            } else {
              item.pageNo = pageNo + 1
            }
          }
        })
      }
    },
    async changeThumbUp (commentId) {
      const res = await changeThumbUp(this.target, commentId)
      if (res.code === 1) {
        this.commentListWithSubCommentList.forEach(item => {
          if (item.id === commentId) {
            if (item.isThumbUp) {
              item.count = Number(item.count) - 1
            } else {
              item.count = Number(item.count) + 1
            }
            item.isThumbUp = !item.isThumbUp
          } else {
            if (item.subCommentList != null) {
              item.subCommentList.forEach(item2 => {
                if (item2.id === commentId) {
                  if (item2.isThumbUp) {
                    item2.count = Number(item2.count) - 1
                  } else {
                    item2.count = Number(item2.count) + 1
                  }
                  item2.isThumbUp = !item2.isThumbUp
                }
              })
            }
          }
        })
      }
    },
    changeReplyTo (user, topId, atId, content) {
      this.replyToUser = user
      this.commentDto.topId = topId
      this.commentDto.atId = atId
      this.commentDto.atUserId = user.id
      this.commentModel = ' @' + this.replyToUser.userName + ' '
      this.commentDto.originalContent = content
      this.$refs.commentInput.focus()
    },
    async sendComment () { // 需要传入topId,at_id
      if (this.replyToUser === null) {
        this.commentDto.topId = 0
        this.commentDto.atId = null
        this.commentDto.atUserId = null
      }
      this.commentDto.goodsId = this.id
      const res = await addComments(this.target, this.commentDto)
      if (res.code === 1) {
        const newCommentVo = {
          ...res.data,
          atUserVo: this.replyToUser,
          userVo: {
            id: this.$store.state.user.user.id,
            userName: this.$store.state.user.user.userName,
            avatar: this.$store.state.user.user.avatar
          },
          pageNo: 1,
          isThumbUp: false,
          subCommentCount: 0,
          topCommentVo: null,
          subCommentList: []
        }
        if (this.commentDto.topId === 0) { // 往整个列表中加
          this.commentListWithSubCommentList.push(newCommentVo)
        } else { // 往子列表中的某个地方加
          this.commentListWithSubCommentList.forEach(item => {
            if (item.id === this.commentDto.topId) {
              item.subCommentList.push(newCommentVo)
            }
          })
        }
        this.commentModel = ''
      }
    },
    toggle () {
      this.showComments = !this.showComments
      this.replyTo = null
      if (this.showComments === true) {
        this.$nextTick(() => {
          this.$refs.commentInput.focus()
          this.commentModel = ''
        })
      }
    },
    goToUserInfo (userId) {
      if (this.$route.path === '/userinfo') {
        return
      }
      this.$router.push({
        path: '/userinfo',
        query: {
          userId
        }
      })
    }
  },
  async created () {
    if (this.$store.getters.token != null) {
      this.commentQuery.userId = this.$store.state.user.user.id
    }
    const res = await getComments(this.target, this.commentQuery)
    if (res.code === 1) {
      this.hasMore = (res.data.list.length === 10)
      this.pageNo = this.pageNo + 1
      this.commentList = res.data.list
      this.commentListWithSubCommentList = this.commentList.map(item => {
        if (item.topCommentVo !== null) {
          let hasMore = false
          if (Number(item.subCommentCount) > 1) {
            hasMore = true
          }
          return {
            ...item,
            subCommentList: new Array(item.topCommentVo),
            pageNo: 1,
            hasMore
          }
        } else {
          const hasMore = false
          return {
            ...item,
            subCommentList: [],
            pageNo: 1, // 用来记录每条主评论下面的翻页数
            hasMore
          }
        }
      })
    }
  },
  watch: {
    commentModel (newVal, oldVal) {
      if (this.replyToUser !== null) {
        if (this.replyToUser.userName !== (newVal.trim().substring(1, this.replyToUser.userName.length + 1))) {
          this.replyToUser = null
          this.commentDto.content = this.commentModel
        } else {
          this.commentDto.content = this.commentModel.substring(this.replyToUser.userName.length + 3)
          console.log(this.commentDto.content)
        }
      } else {
        this.commentDto.content = this.commentModel
      }
      if (newVal.length > 500) {
        this.$message.warning('评论最多只能输入500字')
        this.commentModel = oldVal
      }
    }
  }
}
</script>

<style scoped lang="less">
.report-comment{
  margin-left: 20px;
  cursor: pointer;
}
.load-more{
  cursor: pointer;
  color: #4bb2e9;
  margin-left: 50px;
}
.load-more:hover{
  color: #06a4fa;
}
.toggle{
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 15px;
  cursor: pointer;
}
.comments-container{
  margin-bottom: 10px;
  .comment-item{
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 20px;
    width: 1050px;
    display: flex;
  }
}
.comment-text-container{
      width: 1050px;
      margin: 10px auto;
      height: 100px;
      position: relative;
      .comment-text{
        width: 100%;
        height: 100%;
        display: block;
        margin-top: 5px;
        border: none;
        outline: none;
        background-color: #f7f7f7;
        resize:none;
        overflow-y: auto;
        scrollbar-width: thin;
        padding-top: 10px;
        padding-left: 10px;
        outline: 1px solid #9b9b9b;
      }
      .comment-text:focus{
        outline: 1px solid #06a4fa;
      }
      .comment-btn{
        width: 92px;
        height: 25px;
        font-size: 12px;
        background-color:#06a4fa ;
        border-radius: 5px;
        text-align: center;
        color: white;
        position: absolute;
        right: 10px;
        bottom: 0px;
        line-height: 25px;
      }
    }
</style>
